import React from "react";
import "../designcss/Helpingbusiness.css"

const Growsmarter = () => {
  return (
    <div className="business-wrapper">
      <div className="business-container">
        <div className="grows-smarter">
          <h1>What Is a WhatsApp Campaign</h1>
          {/* <h1>with WhatsApp Automation</h1> */}
        </div>

        <p className="business-api">
          A WhatsApp campaign is a strategic marketing approach where businesses
          send personalized messages, offers, updates, or notifications directly
          to customers via WhatsApp. Unlike generic messaging, a successful
          campaign focuses on timing, relevance, and personalization, creating
          meaningful interactions that drive engagement and conversions.
        </p>

        <div className="vision-mission-container">
          <div className="cardd vision-card">
            <h3>Why WhatsApp Marketing Matters for Businesses</h3>
            <p>
              WhatsApp marketing has become an essential tool for businesses to
              engage customers directly and effectively. With higher open rates
              than traditional email, real-time interaction capabilities, and
              cost-effective sharing of rich media, it allows brands to
              communicate personally at scale.
            </p>
          </div>

          <div className="cardd mission-card">
            <h3>WhatsApp Marketing Campaigns with WoSender</h3>
            <p>
              WhatsApp marketing is a highly effective tool for businesses to
              connect with customers instantly and personally. By offering
              higher open rates, real-time engagement, and the ability to share
              rich media cost-effectively, it ensures messages are seen and
              acted upon.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Growsmarter;
